/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementaryQuestionResponseDto
 */
export interface SupplementaryQuestionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SupplementaryQuestionResponseDto
     */
    supplementaryQuestionResponseId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplementaryQuestionResponseDto
     */
    value?: string | null;
}

/**
 * Check if a given object implements the SupplementaryQuestionResponseDto interface.
 */
export function instanceOfSupplementaryQuestionResponseDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementaryQuestionResponseDtoFromJSON(json: any): SupplementaryQuestionResponseDto {
    return SupplementaryQuestionResponseDtoFromJSONTyped(json, false);
}

export function SupplementaryQuestionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementaryQuestionResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplementaryQuestionResponseId': !exists(json, 'supplementaryQuestionResponseId') ? undefined : json['supplementaryQuestionResponseId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function SupplementaryQuestionResponseDtoToJSON(value?: SupplementaryQuestionResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplementaryQuestionResponseId': value.supplementaryQuestionResponseId,
        'value': value.value,
    };
}

